import actionTypes from './constants';

/* */
const initialState = {
  prevSubscription: null,
  nextSubscription: null,
  paymentSchedule: null,
  loading: false,
  error: null,
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NO_SUBSCRIPTION:
      return {
        ...state,
        prevSubscription: null,
        nextSubscription: null,
        paymentSchedule: null,
        loading: false,
        error: action.payload,
      };
    case actionTypes.LOAD_PAYMENT_SCHEDULE:
      return {
        ...state,
        ...action.payload,
        loading: state.loading,
      };
    case actionTypes.LOAD_SUBSCRIPTION:
      return {
        ...state,
        ...action.payload,
        loading: state.loading,
      };
    default:
      return state;
  }
};
